import { createModel } from '@rematch/core';
import { AccreditationCenterDetails } from '../../api/ApiClient';
import apiConnector from '../../api/ApiConnector';

const initialState: State = {
    info: null,
};

export default createModel({
    state: initialState,
    reducers: {
        setInfo(state, info: AccreditationCenterDetails): State {
            return { ...state, info };
        },
        clearInfo(state): State {
            return { ...state, info: null };
        },
    },
    effects: (dispatch: any) => ({
        async getInfoAsync() {
            const result = await apiConnector.execApi(
              dispatch,
              apiClient => apiClient.getInfo(),
            );
            this.setInfo(result);
        },
    }),
});

interface State {
    info: AccreditationCenterDetails | null;
}
